import { render, staticRenderFns } from "./claimInfo.vue?vue&type=template&id=59618728&scoped=true"
import script from "./claimInfo.vue?vue&type=script&lang=js"
export * from "./claimInfo.vue?vue&type=script&lang=js"
import style0 from "./claimInfo.vue?vue&type=style&index=0&id=59618728&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59618728",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59618728')) {
      api.createRecord('59618728', component.options)
    } else {
      api.reload('59618728', component.options)
    }
    module.hot.accept("./claimInfo.vue?vue&type=template&id=59618728&scoped=true", function () {
      api.rerender('59618728', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/groupOrderManage/groupOrderExamine/claimInfo.vue"
export default component.exports